import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import { t, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Chip from '@mui/material/Chip'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import { useCurrentTime } from '@/hooks/useCurrentTime'
import { useWaitingPatients } from '../model/useWaitingPatients'

/** Patients this account already queued today: one click goes back to their consultation (identity, vital signs). */
export function WaitingPatientsList() {
  useLingui()
  const navigate = useNavigate()
  const now = useCurrentTime()
  const { patients, isLoading } = useWaitingPatients()

  return (
    <Stack spacing={1}>
      <Typography variant="h6" component="h2">
        <Trans>Patients in the waiting room ({patients.length})</Trans>
      </Typography>
      {!isLoading && patients.length === 0 && (
        <Typography color="text.secondary"><Trans>No patient waiting right now.</Trans></Typography>
      )}
      <List aria-label={t`Waiting patients`} disablePadding>
        {patients.map((patient) => {
          const minutes = Math.max(0, now.diff(dayjs(patient.since), 'minute'))
          return (
            <ListItemButton key={patient.consultationId} divider onClick={() => navigate(`/consultations/${patient.consultationId}/live`)}>
              <ListItemText primary={patient.patientLabel} secondary={patient.waitingRoomName} />
              <Chip
                size="small"
                color={patient.withDoctor ? 'success' : 'warning'}
                label={patient.withDoctor ? <Trans>With the doctor</Trans> : <Trans>Waiting for {minutes} min</Trans>}
                sx={{ mr: 1 }}
              />
              <ChevronRightIcon />
            </ListItemButton>
          )
        })}
      </List>
    </Stack>
  )
}
